import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    Table_ReservedWrap: {
        textAlign: "center",
        "& img": {
            display: "inline",
        },
    },
    Table_selectable: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
    },
    Table_LoadingOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "inherit",
        zIndex: 2,
    },
    Table_LoadingSpinner: {
        color: "#FFFFFF",
    },
    DialogHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    SettingsTabsContainer: {
        display: "flex",
    },
    SettingsTabs: {
        flex: 1,
    },
    SettingsContent: {
        flex: 3,
    },
    FloorSettings: {
        display: "flex",
        justifyContent: "space-around",
        "& .FloorSelect": {
            // marginRight: '2rem',
        },
    },
    SettingsDialog: {
        minWidth: 600,
        minHeight: "40vh",
    },
    MoveTablesButton: {
        margin: "0.6rem",
        padding: "0.4rem",
    },
    MenuItem: {
        height: "4rem",
        padding: "12px 16px",
        margin: "4px 0",
        minHeight: "48px", // Minimum touch target size for accessibility
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
    },
    LayoutButtons: {
        display: "flex",
        justifyContent: "space-between",
    },
    Discount: {
        marginBottom: "20px",
        "& .Discount__Title": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "& .Discount__Amounts": {
            display: "flex",
            "& .Number": {
                width: "51px",
                height: "47px",
                background: "#6E7187",
                borderRadius: "8px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textAlign: "center",
                lineHeight: "47px",
                marginRight: "4px",
                cursor: "pointer",
                "&.IsSelected": {
                    background: "rgba(251, 253, 245, 0.75)",
                    color: "#271D1C",
                    border: "1px solid #6E7187",
                },
            },
            "&.Disabled": {
                "& .Number": {
                    background: "#dddddd",
                },
            },
        },
    },
    Table_Amount: {
        position: "absolute",
        bottom: "0",
        // bottom: "-1.5rem",
        left: "0.4rem",
        color: "white",
    },
    Totals: {
        fontSize: "18px",

        "& .title": {
            color: "#271D1C",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "17px",
            marginBottom: "4px",
            textTransform: "uppercase",
        },
        "& .amount": {
            fontWeight: 700,
        },
    },
}));
